<template>
  <div class="limiter">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <div class="container-login100">
      <div class="wrap-login100">
        <div class="login100-pic js-tilt" data-tilt>
          <img src="@/assets/images/illustrator-login.svg" alt="IMG" />
        </div>

        <form
          class="login100-form validate-form"
          method="post"
          @submit.prevent="loginSubmit"
        >
          <div class="container-logo">
            <img src="@/assets/images/logo.png" alt="LOGO" class="logo" />
            <span class="title">{{ pageName }}</span>
          </div>

          <div
            class="form-label-group validate-input"
            data-validate="Valid email is required: ex@abc.xyz"
          >
            <input
              name="userNameOrPhoneOrEmail"
              id="userNameOrPhoneOrEmail"
              type="text"
              class="form-control"
              placeholder=" "
              maxlength="100"
              v-model="userNameOrPhoneOrEmail"
            />
            <label for="userNameOrPhoneOrEmail">
              {{ $t("userNameOrPhoneOrEmail") }}
            </label>
            <img src="@/assets/images/man.svg" />
          </div>

          <div
            class="form-label-group validate-input"
            data-validate="Password is required"
          >
            <input
              name="userPassword"
              id="userPassword"
              v-bind:type="[showPassword ? 'text' : 'password']"
              class="form-control password"
              placeholder=" "
              v-model="password"
            />
            <label for="userPassword">{{ $t("password") }}</label>
            <img src="@/assets/images/passwordlock.svg" />
            <span class="toggle-password">
              <img
                :src="
                  require('@/assets/images/eye-' +
                    [showPassword ? 'show' : 'hide'] +
                    '.svg')
                "
                @click="showPassword = !showPassword"
              />
            </span>
          </div>

          <div class="rememberMe-forgotPassword">
            <!-- <div class="form-group">
              <input
                type="checkbox"
                value="1"
                id="rememberMe"
                class="form-check-input"
              />
              <label for="rememberMe" class="form-check-label">
                {{ $t("rememberMe") }}
              </label>
            </div> -->
            <div class="forget-password" v-if="signUpStatus">
              <router-link to="/sign-up" class="nav-link">
                {{ $t("createAccount") }}
              </router-link>
            </div>
          </div>

          <div class="container-login100-form-btn">
            <button name="login" type="submit" class="login100-form-btn">
              {{ $t("login") }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS, USER_VERSION } from "@/utils/constants";
// import { STATUS } from "@/utils/constants";
// import { EMPLOYEE_TYPE } from "@/utils/constantLists";
import axios from "axios";
import createToastMixin from "@/utils/create-toast-mixin";
import { USER_TYPE, HOME_PAGE } from "@/utils/constants";

export default {
  name: "LoginForm",
  props: {
    userType: {
      type: String,
      default: "",
    },
    pageName: {
      type: String,
      default: "",
    },
    signUpStatus: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userNameOrPhoneOrEmail: "",
      password: "",
      showPassword: false,
      filedType: "password",
    };
  },
  methods: {
    async loginSubmit() {
      this.isLoading = true;
      const data = {
        language: this.language,
        user: this.userNameOrPhoneOrEmail,
        userPassword: this.password,
        userPlatFormToken: USER_VERSION.userPlatFormToken,
        userFirebaseToken: USER_VERSION.userFirebaseToken,
        userVersionNumber: USER_VERSION.userVersionNumber,
        deviceNameEn: USER_VERSION.deviceNameEn,
        deviceVersion: USER_VERSION.deviceVersion,
      };

      if (this.userType == USER_TYPE.employee) {
        try {
          const response = await axios.post(`/Users/EmployeeLogin`, data);
          if (response.data.status == STATUS.SUCCESS) {
            this.showMsg(response.data.msg, true);
            this.$store.dispatch(
              "updateUserData",
              response.data.employeeProfileData
            );
            this.$store.dispatch("updateUserType", this.userType);
            this.$router.push(HOME_PAGE);
          } else {
            this.showMsg(response.data.msg);
          }
        } catch (e) {
          this.showMsg(this.$t("errorCatch"));
        }
      }

      if (this.userType == USER_TYPE.client) {
        try {
          const response = await axios.post(`/Users//ClientLogin`, data);
          if (response.data.status == STATUS.SUCCESS) {
            this.showMsg(response.data.msg, true);
            this.$store.dispatch(
              "updateUserData",
              response.data.clientProfileData
            );
            this.$store.dispatch("updateUserType", this.userType);
            this.$router.push(HOME_PAGE);
          } else {
            this.showMsg(response.data.msg);
          }
        } catch (e) {
          this.showMsg(this.$t("errorCatch"));
        }
      }
      this.isLoading = false;
    },
    togglePassword() {
      if (this.filedType === "password") {
        this.filedType = "text";
      } else {
        this.filedType = "password";
      }
    },
  },
  computed: {},
};
</script>

<style scoped lang="scss"></style>
